import * as Swal from "sweetalert2";
<template>
  <div class="page height-full">
    <app-header title="Goals"/>
    <div class="container-fluid" v-if="isLoading">
      <spinner style="margin-top: 25%"></spinner>
    </div>
    <b-card v-if="items.length > 0 && isLoading == false">
      <div>
        <b-button variant="primary" class="compose-btn" @click="showDialog = true" style="float: right; margin-bottom: 16px;">
          New List
        </b-button>
        <div class="container-fluid">
          <b-alert v-if="showUpgradeBanner" show variant="success" class="alert"><a @click="upgrade" href="#" class="alert-link">Get 25% off ChatRise by upgrading during your free trial! Learn more.</a></b-alert>
          <div class="row my-3">
            <div class="col-md-4">
              <div class="counter-box white r-5 p-3">
                <div class="p-3">
                  <div class="counter-title">Revenue</div>
                  <h5 class="sc-counter mt-3">$2,164.55</h5>
                </div>
              </div>
            </div>
            <br />
            <div class="col-md-4">
              <div class="counter-box white r-5 p-3">
                <div class="p-3">
                  <div class="counter-title">Ad Spend</div>
                  <h5 class="sc-counter mt-3">$624.96</h5>
                </div>
              </div>
            </div>
            <br />
            <div class="col-md-4">
              <div class="counter-box white r-5 p-3">
                <div class="p-3">
                  <div class="counter-title">ROAS</div>
                  <h5 class="sc-counter mt-3">3.47</h5>
                </div>
              </div>
            </div>
            <br />
          </div>
        </div>
        <spinner v-if="isLoading"></spinner>
      </div>
    </b-card>
    <b-card class="page height-full" v-if="items.length == 0 && isLoading == false">
      <b-row>
        <b-col md="12" class="text-center">
          <br />
          <br />
          <br />
          <h2>You haven't created a list.</h2>
          <p>People can text your keyword and opt-in to receive marketing messages from your brand.</p>
          <b-button variant="primary" id="onboarding-create-list" @click="showDialog = true">Create a List</b-button>
        </b-col>
      </b-row>      
    </b-card>
  </div>
</template>

<script>
  import axios from "axios";
  import Constants from "../../Constants";
  import Spinner from '../common/Spinner'
  import * as Swal from "sweetalert2";

  export default {
    name: "Goals",
    components: {
      Spinner
    },
    data: () => {
      return {
        items: [],
        isLoading: false,
        form: {
          id: '',
          isEdit: false,
          name: '',
          keyword: '',
          postSignUpMessage: '',
          monthlyFrequency: 2
        },
        fields: ['name', 'keyword', 'postSignUpMessage', 'monthlyFrequency', 'subscriberCount', 'actions'],
        showDialog: false,
        items: [
          { age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
          { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
          { age: 89, first_name: 'Geneva', last_name: 'Wilson' },
          { age: 38, first_name: 'Jami', last_name: 'Carney' }
        ]
      }
    },
    methods: {
      getLists() {
        this.isLoading = true
        axios
          .get(Constants.API_URL + "/lists")
          .then(response => {
            this.isLoading = false
            console.log(response);
            (this.items = response.data.Items)
          }).catch(() => {
            if (err.response.status == 401) {
              window.location.href = "/lists"
            }
          }).then(() => {
            this.isLoading = false
          })
      },
      reset() {
        this.form.keyword = "";
        this.form.name = "";
        this.form.postSignUpMessage = "";
        this.form.isEdit = false;
        this.showDialog = false;
        this.form.id = "";
      },
      close() {
        this.reset();
        this.showDialog = false
      },
      editList(list) {
        this.form.id = list.item.pk.split("|")[1]
        this.form.isEdit = true;
        this.showDialog = true;
        this.form.keyword = list.item.keyword;
        this.form.name = list.item.name;
        this.form.postSignUpMessage = list.item.postSignUpMessage;
      },
      deleteList(list) {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            this.confirmDelete(list)
          }
        })
      },
      viewListSubscribers(data) {
        console.log(data)
        const listId = this.items[data.index].sk.split('|')[1]
        this.$router.push('/lists/' + listId + '/subscribers')
      },
      confirmDelete(list) {
        this.isLoading = true
        axios
          .delete(Constants.API_URL + "/lists/" + list.item.sk.split("|")[1])
          .then(response => {
            this.isLoading = false
            this.close()
            Swal.fire(
              'Deleted!',
              'Your list has been deleted.',
              'success'
            )
          })
          .finally(() => {
            this.getLists()
          }).catch(() => {
          this.isLoading = false
          Swal.fire(
            'Error!',
            'Your list has not been deleted.',
            'error'
          )
        })
      },
      save() {
        if (!this.form.isEdit) {
          const params = {
            postSignUpMessage: this.form.postSignUpMessage,
            keyword: this.form.keyword,
            name: this.form.name,
            monthlyFrequency: this.form.monthlyFrequency
          }
          this.isLoading = true
          axios
            .post(Constants.API_URL + "/lists", params)
            .then(response => {
              console.log(response)
              this.close()
              Appcues.track('Created List')
              const listId = response.data.listId
              console.log(listId)
              this.$router.push('/lists/' + listId + '/subscribers')
            }).catch(err => {
              console.error(err)
              Swal.fire(
                'Error!',
                'Your list has not been added.',
                'error'
              )
            }).then(() => {
              this.isLoading = false
              this.getLists()
            })
        } else {
          const params = {
            postSignUpMessage: this.form.postSignUpMessage,
            name: this.form.name,
          }
          this.isLoading = true
          axios
            .put(Constants.API_URL + "/lists/" + this.form.id, params)
            .then(response => {
              this.isLoading = false
              this.close()
              Swal.fire(
                'Success!',
                'Your list has been edited',
                'success'
              )
            })
            .finally(() => {
              this.getLists()
            }).catch(() => {
            this.isLoading = false
            Swal.fire(
              'Error!',
              'Your list has not been edited.',
              'error'
            )
          })
        }
      }
    },
    created() {
      this.getLists()
    }
  }
</script>

<style scoped>
  .dialog-content {
    width: 100%;
    padding-right: 60px;
    padding-left: 60px;
  }

  .md-dialog-container {
    width: 50%;
  }

  .delete {
    color: red;
  }

  .delete svg {
    margin-right: 8px;
    color: red;
  }

  .delete span {
    color: red;
  }

  .edit svg {
    margin-right: 8px;
  }

  .action-container {
    margin-top: -10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/goals/Goals.vue